import { ChevronLeft, Close } from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'

import useNestedTracksStore from '@/stores/nestedTracksStore'

import { NESTED_TRACKS_TRAY_ID } from './NestedTracks.constants'
import styles from './NestedTracks.module.css'

const NestedTracksTrayControls = (): JSX.Element => {
	const { t } = useTranslation(['app'])
	const canGoBack = useNestedTracksStore((state) => state.history.length > 1)
	const goBack = useNestedTracksStore((state) => state.goBack)

	return (
		<div className={styles.trayControls}>
			{canGoBack ? (
				<button
					type="button"
					aria-label={t('back')}
					className={styles.trayControlButton}
					onClick={goBack}
				>
					<ChevronLeft />
				</button>
			) : (
				<span className={styles.trayControlSpacer} aria-hidden />
			)}
			<button
				type="button"
				aria-label={t('close')}
				className={styles.trayControlButton}
				onClick={(): void => {
					useNestedTracksStore.getState().clear()
				}}
				{...{ command: 'close', commandfor: NESTED_TRACKS_TRAY_ID }}
			>
				<Close />
			</button>
		</div>
	)
}

export default NestedTracksTrayControls
